function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#002F34"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.296 11.297A6.444 6.444 0 0014.668 8c-.861-2.698-3.475-4.667-6.64-4.667-1.09 0-2.12.24-3.04.657L2.334 1.333h-.999v.917l12.39 12.416h.944v-.942l-2.372-2.427zm-4.267-6.63c2.336 0 4.386 1.35 5.219 3.333a5.124 5.124 0 01-1.923 2.326L9.84 8.841c.12-.255.189-.54.189-.841a2 2 0 00-2-2c-.302 0-.586.068-.842.188L6.026 5.026a5.947 5.947 0 012.003-.36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.164 9.986L6.042 7.864a.828.828 0 01-.006.055c-.004.026-.008.053-.008.081a2 2 0 002 2c.028 0 .055-.004.082-.007a.822.822 0 01.054-.007z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.754 8c.833 1.982 2.939 3.333 5.275 3.333.453 0 .892-.065 1.321-.161l1.09 1.09a7.38 7.38 0 01-2.411.404c-3.165 0-5.834-1.968-6.695-4.666A6.497 6.497 0 013.27 5.09l.949.95A5.203 5.203 0 002.754 8z"
}));

const SvgEyeHidden = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none"
}, props), _ref);

export default SvgEyeHidden;